<template>
   <div class="container-fluid app p-0 position-relative">
    <div class="app__header pe-4 ps-4 pb-3 pt-3">
      <h6 class="mb-0">E-Commerce Rechner</h6>
    </div>
    <div class="app__body p-4">

      <div class="app__menubar mb-4 mt-4">

        <div class="btn-group me-3 dropdown-select mt-2">
          <button type="button" class="btn btn-danger dropdown-toggle" data-bs-display="static" id="targets" data-bs-toggle="dropdown" aria-expanded="false">
            <span>Skalierung & Ziele
            <span class="d-block" v-html="$utils.searchObjectByProperty(menuItemsTargets, currentComponent, 'componentID').longTerm"></span></span>
          </button>
          <ul class="dropdown-menu" aria-labelledby="targets">
            <template v-for="(item, index) in menuItemsTargets" :key="index">
            
            <menuItem 
              :active="item.componentID === currentComponent" 
              :component-id="item.componentID" 
              :short-term="item.shortTerm" 
              :long-term="item.longTerm" 
              v-on:select="ChangeComponent(item.componentID)" />
            </template>
          </ul>
        </div>
       
       

        <div class="btn-group me-3 dropdown-select mt-2">
          <button type="button" class="btn btn-danger dropdown-toggle" data-bs-display="static" id="ecommerce" data-bs-toggle="dropdown" aria-expanded="false">
            <span>E-Commerce Kennzahlen
            <span class="d-block" v-html="$utils.searchObjectByProperty(menuItemsECommerce, currentComponent, 'componentID').longTerm"></span></span>
          </button>
          <ul class="dropdown-menu" aria-labelledby="ecommerce">
            <template v-for="(item, index) in menuItemsECommerce" :key="index">
            
              <menuItem 
              :active="item.componentID === currentComponent" 
              :component-id="item.componentID" 
              :short-term="item.shortTerm" 
              :long-term="item.longTerm" 
              v-on:select="ChangeComponent(item.componentID)" />
            </template>
          </ul>
        </div>

        <div class="btn-group me-3 dropdown-select mt-2">
          <button type="button" class="btn btn-danger dropdown-toggle" data-bs-display="static" id="netcalc" data-bs-toggle="dropdown" aria-expanded="false">
            <span>Brutto / Netto Rechner
            <span class="d-block" v-html="$utils.searchObjectByProperty(menuItemsNet, currentComponent, 'componentID').longTerm"></span></span>
          </button>
          <ul class="dropdown-menu" aria-labelledby="netcalc">
            <template v-for="(item, index) in menuItemsNet" :key="index">
            
              <menuItem 
              :active="item.componentID === currentComponent" 
              :component-id="item.componentID" 
              :short-term="item.shortTerm" 
              :long-term="item.longTerm" 
              v-on:select="ChangeComponent(item.componentID)" />
            </template>
          </ul>
        </div>

      </div>
     
      <component v-bind:is = "currentComponent"/>
   
    </div>
  </div>
</template>

<script>

const menuItemsTargets= [

    {
      componentID: 'salesTarget',
      shortTerm: '',
      longTerm: 'Umsatzerwartung'
    },
    {
      componentID: 'scaleGoals',
      shortTerm: '',
      longTerm: 'E-Commerce Skalierung'
    },
    {
      componentID: 'turnoverGrowth2Percent',
      shortTerm: '',
      longTerm: 'Umsatzwachstums (Prozentual)'
    },
    {
      componentID: 'turnoverGrowth2Absolute',
      shortTerm: '',
      longTerm: 'Umsatzziel / Umsatzsteigerung'
    }
];

const menuItemsNet= [

    {
      componentID: 'gross2Net',
      shortTerm: '',
      longTerm: 'Brutto-Netto Umrechner'
    },
    {
      componentID: 'net2Gross',
      shortTerm: '',
      longTerm: 'Netto-Brutto Umrechner'
    }
];

const menuItemsECommerce= [

    {
      componentID: 'clickThroughRate',
      shortTerm: 'CTR',
      longTerm: 'Click-Through-Rate'
    },
    {
      componentID: 'conversionRate',
      shortTerm: 'CVR',
      longTerm: 'Conversion-Rate'
    },
    {
      componentID: 'costConversion',
      shortTerm: '',
      longTerm: 'Kosten pro Conversion'
    },
    {
      componentID: 'costPerClick',
      shortTerm: 'CPC',
      longTerm: 'Kosten pro Klick'
    },
    {
      componentID: 'costPerMile',
      shortTerm: 'CPM',
      longTerm: 'Kosten per Mile'
    },
    {
      componentID: 'customerAcquisitionCost',
      shortTerm: '',
      longTerm: 'Kundenakquisekosten'
    },
    {
      componentID: 'avgBasket',
      shortTerm: '',
      longTerm: 'Durchschnittlicher Warenkorbwert'
    },
    {
      componentID: 'avgProfit',
      shortTerm: '',
      longTerm: 'Durchschnittliche Marge'
    },
    {
      componentID: 'customerLifetimeValue',
      shortTerm: 'CLV',
      longTerm: 'Customer Lifetime Values'
    },
    {
      componentID: 'customerLoyalty',
      shortTerm: '',
      longTerm: 'Kundenbindungsrate'
    },
    {
      componentID: 'alphaReturns',
      shortTerm: '',
      longTerm: 'Retourenquote'
    },
    {
      componentID: 'costTurnoverRelation',
      shortTerm: 'KUR + KUV',
      longTerm: 'Kosten-Umsatz-Relation & -Verhältnis'
    }
    
    
];


import turnoverGrowth2Percent from "@/components/turnoverGrowth2Percent";
import turnoverGrowth2Absolute from "@/components/turnoverGrowth2Absolute";
import gross2Net from "@/components/gross2Net";
import net2Gross from "@/components/net2Gross";
import clickThroughRate from "@/components/clickThroughRate";
import conversionRate from "@/components/conversionRate";
import costConversion from "@/components/costConversion";
import costPerClick from "@/components/costPerClick";
import costPerMile from "@/components/costPerMile";
import customerAcquisitionCost from "@/components/customerAcquisitionCost";
import avgBasket from "@/components/avgBasket";
import avgProfit from "@/components/avgProfit";
import customerLifetimeValue from "@/components/customerLifetimeValue";
import customerLoyalty from "@/components/customerLoyalty";
import alphaReturns from "@/components/alphaReturns";
import costTurnoverRelation from "@/components/costTurnoverRelation";
import salesTarget from "@/components/salesTarget";
import scaleGoals from "@/components/scaleGoals";

import menuItem from "@/components/ui/menuItem";
import MD5 from "crypto-js/md5";

export default {
  name: 'App',
  data(){
      return{
        currentComponent:null,
        menuItemsTargets: menuItemsTargets,
        menuItemsNet: menuItemsNet,
        menuItemsECommerce: menuItemsECommerce
      }
  },
  components: {
    menuItem,
    turnoverGrowth2Percent,
    turnoverGrowth2Absolute,
    gross2Net,
    net2Gross,
    clickThroughRate,
    conversionRate,
    costConversion,
    costPerClick,
    costPerMile,
    customerAcquisitionCost,
    avgBasket,
    avgProfit,
    customerLifetimeValue,
    customerLoyalty,
    alphaReturns,
    costTurnoverRelation,
    salesTarget,
    scaleGoals,
  },
  methods:{
      init() {
        let tmparr = [].concat(...menuItemsTargets, ...menuItemsNet,...menuItemsECommerce)
    
        const urlparam = this.$utils.getParameterByName('c');
        if(urlparam) {

          const [first] = tmparr.filter( (item)=> {
            return MD5(item.componentID).toString() === urlparam;
          })
          
          
          if(first) {
            this.ChangeComponent(first.componentID);
          } else {
          this.ChangeComponent('salesTarget');
          }
        } else {
          this.ChangeComponent('salesTarget');
        }

      },
      ChangeComponent(NewComponent){
        this.currentComponent = NewComponent;
        const customEvent = new CustomEvent('kpi-changed', {detail: { data: this.currentComponent}})
        document.dispatchEvent(customEvent)
    }
  },
  mounted() {
    this.init();
    
  },
}
</script>


